import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { LogOut, Trophy, Image as ImageIcon } from "lucide-react";
import { ScoreManager } from "./ScoreManager";
import { GalleryManager } from "./GalleryManager";
import { EventManager } from "./EventManager";

export function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("events");
  const { signOut, user } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    window.location.href = "/";
  };

  // 🔐 ADMIN PROTECTION
  if (
    !user ||
    (user.email !== "riad.default2001@gmail.com" &&
      user.email !== "admin@sistc-novafest.edu.au")
  ) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <h2 className="text-xl font-bold text-red-600">Access Denied</h2>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-gray-50">
      {/* HEADER */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold">Admin Dashboard</h1>
            <p className="text-sm text-gray-600">
              SISTC Sports Festival Management
            </p>
          </div>

          <button
            onClick={handleSignOut}
            className="flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded"
          >
            <LogOut className="w-4 h-4" />
            Sign Out
          </button>
        </div>
      </header>

      {/* BODY */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow border">
          {/* TABS */}
          <div className="border-b flex">
            <button
              onClick={() => setActiveTab("events")}
              className={`px-6 py-4 ${
                activeTab === "events"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : ""
              }`}
            >
              🏆 Events
            </button>

            <button
              onClick={() => setActiveTab("scores")}
              className={`px-6 py-4 ${
                activeTab === "scores"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : ""
              }`}
            >
              <Trophy className="inline w-4 h-4 mr-1" />
              Scores
            </button>

            <button
              onClick={() => setActiveTab("gallery")}
              className={`px-6 py-4 ${
                activeTab === "gallery"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : ""
              }`}
            >
              <ImageIcon className="inline w-4 h-4 mr-1" />
              Gallery
            </button>
          </div>

          {/* CONTENT */}
          <div className="p-6">
            {activeTab === "events" && <EventManager />}
            {activeTab === "scores" && <ScoreManager />}
            {activeTab === "gallery" && <GalleryManager />}
          </div>
        </div>
      </div>
    </div>
  );
}
